/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PersonTypeDTO } from './personTypeDTO';


export interface GuestDTO { 
    guestId: string;
    /**
     * the first name of the guest
     */
    firstName: string;
    /**
     * the optional middle name of the guest
     */
    middleName?: string;
    /**
     * the last name of the guest
     */
    lastName: string;
    /**
     * the cabin number of the guest
     */
    cabinNumber: string;
    embarkationDate: string;
    disembarkationDate: string;
    type: PersonTypeDTO;
    /**
     * the saluation of the guest
     */
    salutation: string;
    /**
     * the optional title of the guest
     */
    title?: string;
    /**
     * the boardcard number of the guest
     */
    boardcardNumber: string;
    birthdate: string;
    sex: GuestDTO.SexEnum;
    clubStatus?: GuestDTO.ClubStatusEnum;
    imageUri?: string;
}
export namespace GuestDTO {
    export const SexEnum = {
        male: 'male',
        female: 'female',
        diverse: 'diverse'
    } as const;
    export type SexEnum = typeof SexEnum[keyof typeof SexEnum];
    export const ClubStatusEnum = {
        sun: 'sun',
        ocean: 'ocean',
        smile: 'smile',
        kiss: 'kiss'
    } as const;
    export type ClubStatusEnum = typeof ClubStatusEnum[keyof typeof ClubStatusEnum];
}


